// ユーザーx講座バッジ情報
export class UserPlanBadge {
  constructor(
    public src: string, // バッジ画像URL
    public name: string, // バッジ名
  ) {}
}
